(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jba-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jba-catalog')) {
  customElements.define('jba-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = Array.from(this.querySelectorAll('.jba-catalog-card')).map(card => ({ element: card, shape: card.dataset.shape, carat: Number(card.dataset.carat) }));
      this.shape = this.querySelector('[data-jba-shape]');
      this.carat = this.querySelector('[data-jba-carat]');
      this.count = this.querySelector('[data-jba-result-count]');
      this.empty = this.querySelector('[data-jba-empty]');
      this.reset = this.querySelector('.jba-catalog__reset');
      this.shape.disabled = false;
      this.carat.disabled = false;
      this.addEventListener('change', event => {
        if (event.target === this.shape || event.target === this.carat) this.filter();
      });
      this.addEventListener('click', event => {
        const reset = event.target.closest('[data-jba-reset]');
        if (!reset || !this.contains(reset)) return;
        this.shape.value = '';
        this.carat.value = '';
        this.filter();
        this.shape.focus({ preventScroll: true });
      });
      this.filter();
    }
    filter() {
      const shape = this.shape.value;
      const carat = this.carat.value;
      let visible = 0;
      for (const card of this.cards) {
        const match = (!shape || card.shape === shape) && (!carat || card.carat === Number(carat));
        card.element.hidden = !match;
        if (match) visible++;
      }
      this.count.textContent = visible === 1 ? this.dataset.countSingular : this.dataset.countTemplate.replace('__COUNT__', String(visible));
      this.empty.hidden = visible > 0;
      this.reset.disabled = !shape && !carat;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jba-category"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jba-category')) {
  customElements.define('jba-category', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.states = new Map(Array.from(this.querySelectorAll('template[data-state]'), (node) => [node.dataset.state, node.dataset]));
      this.stage = this.querySelector('[data-stage]');
      this.photo = this.querySelector('[data-photo]');
      this.selection = this.querySelector('[data-selection]');
      this.imageLabel = this.querySelector('[data-image-label]');
      this.status = this.querySelector('[data-image-status]');
      this.config = this.querySelector('[data-config]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.requestId = 0;
      this.visibleKey = 'white-low';
      if (this.states.size !== 6 || !this.photo) return;
      this.querySelectorAll('[data-selectors]').forEach((fieldset) => { fieldset.disabled = false; });
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-metal], [data-weight]')) return;
        this.updateImage();
      });
      this.closest('section')?.addEventListener('shopify:section:unload', () => { this.requestId += 1; });
    }
    async updateImage() {
      const metal = this.querySelector('[data-metal]:checked').value;
      const weight = this.querySelector('[data-weight]:checked').value;
      const key = `${metal}-${weight}`;
      const state = this.states.get(key);
      if (!state) return;
      const requestId = ++this.requestId;
      this.selection.textContent = state.label;
      if (this.config) this.config.value = `${this.dataset.title} — ${state.label}`;
      if (key === this.visibleKey) {
        this.stage.removeAttribute('aria-busy');
        this.status.textContent = '';
        return;
      }
      this.stage.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      const next = new Image(512, 512);
      next.className = 'jba-category__photo';
      next.alt = state.alt;
      next.decoding = 'async';
      next.sizes = state.sizes;
      next.srcset = state.srcset;
      next.src = state.src;
      try {
        await next.decode();
        if (requestId !== this.requestId || !this.isConnected) return;
        const previous = this.photo;
        this.photo = next;
        this.stage.append(next);
        if (this.reducedMotion.matches) {
          previous.remove();
        } else {
          next.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' }).finished.catch(() => {}).then(() => previous.remove());
        }
        this.visibleKey = key;
        this.imageLabel.textContent = state.label;
        this.stage.removeAttribute('aria-busy');
        this.status.textContent = this.dataset.loaded;
      } catch {
        if (requestId !== this.requestId || !this.isConnected) return;
        this.stage.removeAttribute('aria-busy');
        this.status.textContent = this.dataset.error;
      }
    }
    disconnectedCallback() {
      this.requestId += 1;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jba-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-jba-search-close]');
    if (close) { const panel = close.closest('details'); panel.open = false; panel.querySelector('summary').focus(); }
    const link = event.target.closest('.jba-header__mobile nav a');
    if (link) link.closest('details').open = false;
    document.querySelectorAll('.jba-search[open],.jba-header__mobile[open]').forEach(panel => { if (!panel.contains(event.target)) panel.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const panels = document.querySelectorAll('.jba-search[open],.jba-header__mobile[open]');
    panels.forEach(panel => { panel.open = false; panel.querySelector('summary').focus(); });
  });
  document.addEventListener('toggle', event => {
    const panel = event.target;
    if (!panel.matches?.('.jba-search,.jba-header__mobile') || !panel.open) return;
    document.querySelectorAll('.jba-search[open],.jba-header__mobile[open]').forEach(other => { if (other !== panel) other.open = false; });
    if (panel.matches('.jba-search')) panel.querySelector('input[type="search"]').focus();
  }, true);
  document.addEventListener('focusout', event => {
    const panel = event.target.closest('.jba-search,.jba-header__mobile');
    if (panel?.open && event.relatedTarget && !panel.contains(event.relatedTarget)) panel.open = false;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jba-product"]) return;
  try {
    
  if (!customElements.get('jba-product')) {
    customElements.define('jba-product', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.requestId = 0;
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-variant]')) this.selectVariant(event.target.value);
        });
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-variant-link]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          const radio = this.querySelector(`[data-variant][value="${link.dataset.variantLink}"]`);
          if (radio) {
            radio.checked = true;
            this.selectVariant(radio.value);
          }
        });
        this.querySelector('form').addEventListener('submit', (event) => {
          const variant = this.variants.find((item) => String(item.id) === this.querySelector('[data-variant]:checked')?.value);
          if (!variant || !variant.available || variant.price <= 0 || this.dataset.productAvailable !== 'true') event.preventDefault();
        });
      }
      selectVariant(id) {
        const variant = this.variants.find((item) => String(item.id) === String(id));
        if (!variant) return;
        const canPurchase = this.dataset.productAvailable === 'true' && variant.available && variant.price > 0;
        this.querySelector('[data-price]').textContent = variant.price > 0 ? variant.money : this.dataset.soonLabel;
        this.querySelector('[data-add]').disabled = !canPurchase;
        this.querySelector('[data-add-text]').textContent = canPurchase ? this.dataset.addLabel : variant.price > 0 ? this.dataset.soldLabel : this.dataset.soonLabel;
        this.querySelector('[data-availability]').hidden = canPurchase;
        this.querySelectorAll('[data-variant-link]').forEach((link) => {
          if (String(link.dataset.variantLink) === String(id)) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState(window.history.state, '', url);
        this.querySelectorAll('[data-carat-link]').forEach((link) => {
          const variantId = link.dataset[`variant${variant.metal.toLowerCase().includes('rose') ? 'Rose' : variant.metal.toLowerCase().includes('yellow') ? 'Yellow' : 'White'}`];
          if (!variantId) return;
          const destination = new URL(link.href, window.location.href);
          destination.searchParams.set('variant', variantId);
          link.href = destination.href;
        });
        this.updateImage(variant);
      }
      async updateImage(variant) {
        const sequence = ++this.requestId;
        const status = this.querySelector('[data-image-status]');
        if (!variant.image) {
          status.textContent = this.dataset.imageError;
          return;
        }
        const current = this.querySelector('.jba-product__image');
        if (current && current.getAttribute('src') === variant.image.src) return;
        const next = new Image(variant.image.width, variant.image.height);
        next.className = 'jba-product__image';
        next.alt = variant.image.alt;
        next.sizes = current?.sizes || '(min-width: 1200px) 580px, (min-width: 900px) 48vw, 92vw';
        next.srcset = variant.image.srcset;
        next.src = variant.image.src;
        status.textContent = '';
        try {
          await next.decode();
          if (sequence !== this.requestId || !this.isConnected) return;
          const swap = () => {
            if (sequence !== this.requestId || !this.isConnected) return;
            this.querySelector('[data-stage]').replaceChildren(next);
            this.querySelector('[data-image-label]').textContent = variant.metal;
            status.textContent = this.dataset.imageLoaded.replace('[metal]', variant.metal);
          };
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!reduceMotion && document.startViewTransition) {
            this.transition?.skipTransition();
            this.transition = document.startViewTransition(swap);
            this.transition.ready.catch(() => {});
            await this.transition.updateCallbackDone;
          } else {
            swap();
            if (!reduceMotion) next.animate([{ opacity: 0.45 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' });
          }
        } catch {
          if (sequence === this.requestId) status.textContent = this.dataset.imageError;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jba-studio-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jba-studio-collection')) customElements.define('jba-studio-collection', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.grid = this.querySelector('.jba-studio-collection__grid');
    this.cards = Array.from(this.querySelectorAll('[data-jba-studio-card]')).map((element, index) => ({ element, index, style: element.dataset.style || '', shapes: (element.dataset.shapes || '').split('|').map(value => value.trim()).filter(Boolean), price: Number(element.dataset.price) || 0, title: element.querySelector('h2').textContent.trim() }));
    this.styleControl = this.querySelector('[data-studio-style]');
    this.shapeControl = this.querySelector('[data-studio-shape]');
    this.budgetControl = this.querySelector('[data-studio-budget]');
    this.sortControl = this.querySelector('[data-studio-sort]');
    const populate = (control, values) => Array.from(new Set(values)).filter(Boolean).sort().forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; control.append(option); });
    populate(this.styleControl, this.cards.map(card => card.style));
    populate(this.shapeControl, this.cards.flatMap(card => card.shapes));
    [this.styleControl, this.shapeControl, this.budgetControl, this.sortControl].forEach(control => { control.disabled = false; });
    this.addEventListener('change', event => { if (event.target.matches('select')) this.filter(); });
    this.addEventListener('click', event => {
      if (!event.target.closest('[data-studio-reset]')) return;
      this.styleControl.value = ''; this.shapeControl.value = ''; this.budgetControl.value = ''; this.filter(); this.styleControl.focus({ preventScroll: true });
    });
    this.filter();
  }
  filter() {
    let visible = 0;
    const style = this.styleControl.value, shape = this.shapeControl.value, budget = Number(this.budgetControl.value);
    this.cards.forEach(card => { const show = (!style || card.style === style) && (!shape || card.shapes.includes(shape)) && (!budget || card.price > 0 && card.price < budget); card.element.hidden = !show; if (show) visible++; });
    const sort = this.sortControl.value;
    const ordered = [...this.cards].sort((a, b) => sort === 'price-ascending' ? a.price - b.price || a.index - b.index : sort === 'price-descending' ? b.price - a.price || a.index - b.index : sort === 'title' ? a.title.localeCompare(b.title) : a.index - b.index);
    ordered.forEach(card => this.grid.append(card.element));
    this.querySelector('[data-studio-count]').textContent = visible === 1 ? this.dataset.countSingle : this.dataset.countTemplate.replace('__COUNT__', String(visible));
    this.querySelector('[data-studio-empty]').hidden = visible > 0;
    this.querySelector('.jba-studio-collection__results [data-studio-reset]').hidden = !style && !shape && !budget;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jba-studio-product"]) return;
  try {
    
if (!customElements.get('jba-studio-product')) {
  customElements.define('jba-studio-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      try {
        this.studio = JSON.parse(this.querySelector('[data-studio]').textContent) || {};
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent) || {};
        this.native = JSON.parse(this.querySelector('[data-native-state]').textContent) || {};
      } catch {
        this.querySelector('[data-status]').textContent = this.dataset.startupError;
        return;
      }
      this.rows = Array.isArray(this.studio.variants) ? this.studio.variants : [];
      this.byId = new Map(this.rows.map(row => [String(row[0]), row]));
      this.byConfiguration = new Map(this.rows.map(row => [this.key(row[1], row[2], row[3], row[4], row[5]), row]));
      this.metals = this.studio.metals || [];
      this.shapes = this.studio.shapes || [];
      this.carats = this.studio.carats || [];
      this.productions = this.studio.production || [{id:'standard',duration:'3 Weeks',fee:0}];
      this.requestSequence = 0;
      this.imageSequence = 0;
      this.current = this.byId.get(String(this.native.id)) || this.byId.get(String(this.studio.default?.variantId)) || this.rows[0];
      this.form = this.querySelector('form');
      this.submitting = false;
      this.galleryIndex = 0;
      this.zoomSequence = 0;
      const incoming = new URL(window.location.href);
      for (const [param, selector] of [['jba_size','[data-ring-size]'],['jba_length','[data-length-select]']]) {
        const input = this.querySelector(selector);
        const saved = incoming.searchParams.get(param);
        if (input && [...input.options].some(option => option.value === saved)) input.value = saved;
      }
      const signal = this.abort.signal;
      this.addEventListener('change', event => this.onChange(event), {signal});
      this.addEventListener('input', event => this.onInput(event), {signal});
      this.addEventListener('click', event => this.onClick(event), {signal});
      this.addEventListener('keydown', event => this.onGalleryKey(event), {signal});
      this.form.addEventListener('submit', event => this.submitToBag(event), {signal});
      this.form.addEventListener('invalid', event => {
        if (!event.target.matches('[data-ring-size]')) return;
        event.target.setAttribute('aria-invalid','true');
        this.querySelector('[data-status]').textContent = this.labels.selectSize;
      }, {signal,capture:true});
      window.addEventListener('pageshow', event => {
        if (!event.persisted || !this.current) return;
        this.submitting = false;
        this.querySelector('[data-configurator-controls]').disabled = false;
        this.form.setAttribute('aria-busy','false');
        this.fetchVariant(this.current);
      }, {signal});
      document.addEventListener('jba:wishlist-updated', () => this.updateWishlist(), {signal});
      const dialog = this.querySelector('[data-photo-dialog]');
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, {signal});
      dialog.addEventListener('close', () => {
        ++this.zoomSequence;
        this.querySelector('[data-photo-zoom]').focus({preventScroll:true});
      }, {signal});
      if (this.current) {
        this.syncControls();
        this.updateGallery(false);
        if (String(this.current[0]) !== String(this.native.id)) this.fetchVariant(this.current);
        else this.applyNative(this.native);
      } else this.failClosed(this.labels.unavailable);
      this.updateWishlist();
      this.querySelector('[data-configurator-controls]').disabled = !this.current;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.priceRequest?.abort();
      this.cartRequest?.abort();
      clearTimeout(this.priceTimer);
      ++this.imageSequence;
      ++this.zoomSequence;
      this.initialized = false;
    }
    key(metal, shape, carat, width, production = 'standard') {
      return [metal, shape, Number(carat), Number(width || 0), production || 'standard'].join('|');
    }
    configuration() {
      const row = this.current;
      const metal = this.metals.find(value => value.id === row?.[1]);
      const shape = this.shapes.find(value => value.id === row?.[2]);
      const length = this.querySelector('[data-length-select]')?.selectedOptions?.[0]?.dataset.lengthValue ?? this.studio.length?.value ?? this.studio.length?.default;
      return {category:this.studio.category,style:this.studio.style,shape:shape?.id || row?.[2],carat:Number(row?.[3]),metal:metal?.label || row?.[1],width:Number(row?.[4] || 0),ringSize:this.querySelector('[data-ring-size]')?.value ? Number(this.querySelector('[data-ring-size]').value) : undefined,length:length ? Number(length) : undefined,productionId:row?.[5] || 'standard'};
    }
    onChange(event) {
      if (!this.current || this.submitting) return;
      if (event.target.matches('[data-choice]')) {
        const metal = this.querySelector('[data-choice="metal"]:checked')?.value || this.current[1];
        const shape = this.querySelector('[data-choice="shape"]:checked')?.value || this.current[2];
        const width = Number(this.querySelector('[data-choice="width"]:checked')?.value || this.current[4]);
        const production = this.querySelector('[data-choice="production"]:checked')?.value || this.current[5] || 'standard';
        this.select(this.byConfiguration.get(this.key(metal, shape, this.current[3], width, production)));
      } else if (event.target.matches('[data-carat-range]')) {
        this.selectCarat(this.carats[Number(event.target.value)]);
      } else if (event.target.matches('[data-ring-size], [data-length-select]')) {
        event.target.removeAttribute('aria-invalid');
        this.querySelector('[data-status]').textContent = '';
        this.syncControls(); this.updateUrl(); this.updateWishlist();
        this.refreshPurchase();
      }
    }
    onInput(event) {
      if (event.target.matches('[data-carat-range]')) this.selectCarat(this.carats[Number(event.target.value)], true);
    }
    onClick(event) {
      const photoButton = event.target.closest('[data-photo-index]');
      if (photoButton) this.showPhoto(Number(photoButton.dataset.photoIndex), true);
      const caratButton = event.target.closest('[data-carat]');
      if (caratButton) this.selectCarat(Number(caratButton.dataset.carat));
      if (event.target.closest('[data-photo-zoom]')) this.openPhoto();
      if (event.target.closest('[data-photo-close]')) this.querySelector('[data-photo-dialog]').close();
      if (event.target.closest('[data-price-retry]') && this.current && !this.pending) this.fetchVariant(this.current);
      if (event.target.closest('[data-image-retry]')) this.showPhoto(this.requestedPhotoIndex || 0,true);
      if (event.target.closest('[data-zoom-retry]')) this.loadZoom();
      if (event.target.closest('[data-photo-prev]')) this.showPhoto((this.galleryIndex - 1 + this.gallery.length) % this.gallery.length,true);
      if (event.target.closest('[data-photo-next]')) this.showPhoto((this.galleryIndex + 1) % this.gallery.length,true);
      if (event.target.closest('[data-jba-wishlist-toggle]')) document.dispatchEvent(new CustomEvent('jba:wishlist-toggle', {detail:this.wishlistItem()}));
      if (event.target.closest('[data-mobile-add]')) {
        if (!this.form.checkValidity()) { this.form.reportValidity(); this.querySelector(':invalid')?.scrollIntoView({block:'center'}); }
        else this.form.requestSubmit(this.querySelector('[data-add]'));
      }
    }
    selectCarat(carat, debounce = false) {
      if (!this.current) return;
      this.select(this.byConfiguration.get(this.key(this.current[1],this.current[2],carat,this.current[4],this.current[5])),debounce);
    }
    select(row, debounce = false) {
      if (this.submitting) return;
      if (!row) { this.failClosed(this.labels.unavailable); return; }
      if (String(row[0]) === String(this.current?.[0])) {
        if (!this.native && !this.pending) this.fetchVariant(row);
        return;
      }
      const previous = this.current;
      this.current = row;
      this.syncControls();
      if (!previous || previous.slice(1,5).join('|') !== row.slice(1,5).join('|')) this.updateGallery(true);
      this.updateUrl(); this.updateWishlist();
      this.pending = true;
      this.priceRequest?.abort();
      ++this.requestSequence;
      clearTimeout(this.priceTimer);
      this.setPriceBusy(true);
      this.setPurchase(false,this.labels.updating);
      this.querySelector('[data-status]').textContent = '';
      if (debounce) this.priceTimer = setTimeout(() => this.fetchVariant(row),160);
      else this.fetchVariant(row);
    }
    syncControls() {
      const row = this.current;
      const metal = this.metals.find(value => value.id === row[1]);
      const shape = this.shapes.find(value => value.id === row[2]);
      const production = this.productions.find(value => value.id === (row[5] || 'standard'));
      const values = {metal:row[1],shape:row[2],width:row[4],production:row[5] || 'standard'};
      this.querySelectorAll('[data-choice]').forEach(input => { input.checked = String(input.value) === String(values[input.dataset.choice]); });
      const caratIndex = this.carats.findIndex(value => Number(value) === Number(row[3]));
      const range = this.querySelector('[data-carat-range]');
      if (range) { range.value = Math.max(0,caratIndex); range.setAttribute('aria-valuetext',`${row[3]} ${this.labels.ct}`); }
      this.querySelectorAll('[data-carat]').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.carat) === Number(row[3]))));
      const productionLabel = production?.id === 'expedited' ? this.labels.expedited : this.labels.standard;
      const labels = {metal:metal?.label || row[1],shape:shape?.label || row[2],carat:`${row[3]} ${this.labels.ct}`,width:`${row[4]} ${this.labels.mm}`,size:this.querySelector('[data-ring-size]')?.value || this.labels.selectSize,length:this.querySelector('[data-length-select]')?.value || this.studio.length?.label || (this.studio.length ? `${this.studio.length.value || this.studio.length.default || ''} ${this.studio.length.unit || ''}`.trim() : ''),production:`${productionLabel} · ${production?.duration || '3 Weeks'}`};
      for (const [key,value] of Object.entries(labels)) {
        const label = this.querySelector(`[data-${key}-label]`);
        if (label) label.textContent = value;
        this.querySelectorAll(`[data-spec="${key}"]`).forEach(element => { element.textContent = value; });
      }
      const summary = [labels.metal,labels.shape,labels.carat];
      if (Number(row[4]) > 0) summary.push(labels.width);
      if (this.querySelector('[data-ring-size]')?.value) summary.push(`${this.labels.size} ${labels.size}`);
      if (labels.length) summary.push(labels.length);
      this.querySelector('[data-configuration-summary]').textContent = summary.join(' · ');
      this.querySelector('[data-variant-id]').value = String(row[0]);
      const productionProperty = this.querySelector('[data-production-property]');
      if (productionProperty) productionProperty.value = labels.production;
      this.dispatchEvent(new CustomEvent('jba:configuration-changed',{bubbles:true,detail:{...this.configuration(),metalId:row[1],variantId:String(row[0])}}));
    }
    async fetchVariant(row) {
      const sequence = ++this.requestSequence;
      this.priceRequest?.abort();
      this.priceRequest = new AbortController();
      const controller = this.priceRequest;
      const timeout = setTimeout(() => controller.abort(),15000);
      this.pending = true;
      this.setPriceBusy(true);
      this.setPurchase(false,this.labels.updating);
      this.querySelector('[data-price-retry]').hidden = true;
      this.querySelector('[data-status]').textContent = '';
      const request = new URL(window.location.href);
      request.searchParams.set('variant',String(row[0]));
      request.searchParams.set('section_id','jba-studio-variant');
      request.searchParams.delete('sections');
      try {
        const response = await fetch(request,{signal:controller.signal,credentials:'same-origin',headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('variant_response');
        const html = await response.text();
        if (sequence !== this.requestSequence || !this.isConnected) return;
        const fragment = new DOMParser().parseFromString(html,'text/html');
        const state = JSON.parse(fragment.querySelector('[data-native-state]')?.textContent || 'null');
        if (!state || String(state.id) !== String(row[0]) || !Number.isFinite(state.price) || typeof state.money !== 'string') throw new Error('variant_mismatch');
        this.applyNative(state);
      } catch {
        if (sequence === this.requestSequence && this.isConnected) this.failClosed(this.labels.priceError);
      } finally { clearTimeout(timeout); }
    }
    applyNative(state) {
      this.native = state;
      this.pending = false;
      this.setPriceBusy(false);
      this.querySelector('[data-price-retry]').hidden = true;
      this.setPrice(state.price > 0 ? state.money : this.labels.priceError);
      const buyable = Boolean(this.studio.saleEnabled && state.buyable && state.available && state.price > 0 && String(state.id) === String(this.current?.[0]));
      this.refreshPurchase();
      const availability = this.querySelector('[data-availability]');
      availability.hidden = buyable;
      availability.textContent = this.studio.saleEnabled ? this.labels.soldOut : this.labels.previewNote;
      this.querySelector('[data-status]').textContent = '';
    }
    refreshPurchase() {
      const state = this.native;
      const buyable = Boolean(!this.pending && !this.submitting && this.studio.saleEnabled && state?.buyable && state?.available && state.price > 0 && String(state.id) === String(this.current?.[0]));
      const size = this.querySelector('[data-ring-size]');
      const label = this.submitting ? this.labels.adding : this.pending ? this.labels.updating : buyable ? size && !size.value ? this.labels.selectSize : this.labels.add : this.studio.saleEnabled ? this.labels.soldOut : this.labels.preview;
      this.setPurchase(buyable,label);
    }
    setPriceBusy(busy) {
      this.querySelector('[data-price]').setAttribute('aria-busy',String(busy));
      this.querySelector('[data-mobile-price]').setAttribute('aria-busy',String(busy));
      this.querySelector('[data-price-status]').textContent = busy ? this.labels.updating : '';
      this.querySelector('[data-price]').classList.toggle('is-updating',busy);
      this.querySelector('[data-mobile-price]').classList.toggle('is-updating',busy);
    }
    setPrice(value) {
      this.querySelector('[data-price]').textContent = value;
      this.querySelector('[data-mobile-price]').textContent = value;
    }
    setPurchase(enabled,label) {
      this.querySelector('[data-add]').disabled = !enabled;
      this.querySelector('[data-add-label]').textContent = label;
      const mobile = this.querySelector('[data-mobile-add]');
      mobile.disabled = !enabled; mobile.textContent = label;
    }
    failClosed(message) {
      ++this.requestSequence;
      this.priceRequest?.abort(); clearTimeout(this.priceTimer);
      this.pending = false; this.native = null;
      this.setPriceBusy(false);
      this.querySelector('[data-price-retry]').hidden = !this.current;
      this.setPrice(this.labels.priceError); this.setPurchase(false,this.labels.soldOut);
      this.querySelector('[data-status]').textContent = message;
    }
    async submitToBag(event) {
      event.preventDefault();
      if (this.submitting || this.pending || !this.native?.buyable || !this.native.available || !this.studio.saleEnabled || this.native.price <= 0 || String(this.native.id) !== String(this.current?.[0])) return;
      if (!this.form.checkValidity()) { this.form.reportValidity(); return; }
      const body = new FormData(this.form);
      if (String(body.get('id')) !== String(this.current[0])) return;
      this.submitting = true;
      this.cartRequest = new AbortController();
      const timeout = setTimeout(() => this.cartRequest.abort(),20000);
      this.querySelector('[data-configurator-controls]').disabled = true;
      this.form.setAttribute('aria-busy','true');
      this.refreshPurchase();
      this.querySelector('[data-status]').textContent = this.labels.adding;
      this.querySelector('[data-cart-recovery]').hidden = true;
      let complete = false;
      try {
        const response = await fetch(this.dataset.cartAddUrl,{method:'POST',body,signal:this.cartRequest.signal,credentials:'same-origin',headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          this.querySelector('[data-status]').textContent = typeof result.description === 'string' ? result.description : this.labels.cartError;
          return;
        }
        if (String(result.variant_id || result.id) !== String(this.current[0])) throw new Error('cart_response');
        complete = true;
        this.querySelector('[data-status]').textContent = this.labels.added;
        window.location.assign(this.dataset.cartUrl);
      } catch {
        if (this.isConnected) this.querySelector('[data-status]').textContent = this.labels.cartUnknown;
      } finally {
        clearTimeout(timeout);
        if (!complete && this.isConnected) {
          this.submitting = false;
          this.querySelector('[data-configurator-controls]').disabled = false;
          this.form.setAttribute('aria-busy','false');
          this.refreshPurchase();
          this.querySelector('[data-cart-recovery]').hidden = false;
        }
      }
    }
    onGalleryKey(event) {
      if (!event.target.closest('[data-photo-thumbnails]') || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      const buttons = [...this.querySelectorAll('[data-photo-index]')];
      if (!buttons.length) return;
      event.preventDefault();
      const index = buttons.indexOf(event.target.closest('[data-photo-index]'));
      const target = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      buttons[target].focus(); buttons[target].click();
    }
    imageMatches(image,row = this.current) {
      return Boolean(row && image.metalId === row[1] && image.shapeId === row[2] && Number(image.carat) === Number(row[3]) && Number(image.width || 0) === Number(row[4] || 0));
    }
    photosForConfiguration() {
      return (this.studio.images || []).filter(image => image.url && this.imageMatches(image));
    }
    referencePhotos() {
      const images = (this.studio.images || []).filter(image => image.url);
      if (!images.length || !this.current) return images;
      const row = this.current;
      const score = image => (image.shapeId === row[2] ? 1000 : 0) + (image.metalId === row[1] ? 100 : 0) - Math.abs(Number(image.carat) - Number(row[3])) * 10 - Math.abs(Number(image.width || 0) - Number(row[4] || 0));
      const reference = images.reduce((best,image) => score(image) > score(best) ? image : best,images[0]);
      return images.filter(image => image.metalId === reference.metalId && image.shapeId === reference.shapeId && Number(image.carat) === Number(reference.carat) && Number(image.width || 0) === Number(reference.width || 0));
    }
    updateGallery(animate) {
      const previousView = this.currentPhoto?.view;
      const matches = this.photosForConfiguration();
      this.gallery = matches.length ? matches : this.referencePhotos();
      this.gallery.sort((a,b) => Number(a.view === 'profile') - Number(b.view === 'profile'));
      const thumbnails = this.querySelector('[data-photo-thumbnails]');
      thumbnails.replaceChildren();
      thumbnails.hidden = this.gallery.length < 2;
      this.querySelector('[data-gallery-navigation]').hidden = this.gallery.length < 2;
      this.gallery.forEach((photo,index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.photoIndex = index;
        button.className = 'jba-studio__thumbnail';
        button.setAttribute('aria-label',`${this.labels.image} ${index + 1} · ${this.photoViewLabel(photo)}`);
        button.setAttribute('aria-pressed','false');
        button.setAttribute('aria-controls',this.querySelector('[data-panel="photo"]').id);
        button.tabIndex = index === 0 ? 0 : -1;
        const thumbnail = document.createElement('img');
        thumbnail.src = this.imageUrl(photo.url,160); thumbnail.alt = ''; thumbnail.width = 80; thumbnail.height = 80;
        thumbnail.loading = 'lazy'; thumbnail.decoding = 'async';
        button.append(thumbnail); thumbnails.append(button);
      });
      this.updateVisualNote();
      if (this.gallery.length) this.showPhoto(Math.max(0,this.gallery.findIndex(photo => photo.view === previousView)),animate);
      else { ++this.imageSequence; this.querySelector('[data-photo-zoom]').disabled = true; }
    }
    photoViewLabel(photo) {
      return photo.view === 'profile' ? this.labels.sideView : photo.view === 'top' ? this.labels.topView : this.labels.designView;
    }
    imageUrl(url,width) {
      const result = new URL(url,window.location.href);
      if (result.hostname.endsWith('shopify.com') || result.pathname.startsWith('/cdn/shop/')) result.searchParams.set('width',String(width));
      return result.href;
    }
    sameImage(left,right) {
      const a = new URL(left,window.location.href), b = new URL(right,window.location.href);
      return a.pathname.split('/').pop() === b.pathname.split('/').pop() && ['v','crop','crop_left','crop_top','crop_width','crop_height'].every(key => a.searchParams.get(key) === b.searchParams.get(key));
    }
    async showPhoto(index,animate) {
      const photo = this.gallery?.[index];
      if (!photo) return;
      const sequence = ++this.imageSequence;
      this.requestedPhotoIndex = index;
      const panel = this.querySelector('[data-panel="photo"]');
      panel.setAttribute('aria-busy','true');
      this.querySelector('[data-image-loading]').hidden = false;
      this.querySelector('[data-image-retry]').hidden = true;
      this.querySelector('[data-image-status]').textContent = '';
      const current = this.querySelector('.jba-studio__image');
      try {
        if (current && this.sameImage(current.currentSrc || current.src,photo.url) && (!current.complete || current.naturalWidth > 0)) {
          if (!current.complete) await current.decode();
          if (!current.naturalWidth) throw new Error('image_empty');
        } else {
          const next = new Image(photo.pixelWidth || 1440,photo.pixelHeight || 1440);
          next.className = 'jba-studio__image'; next.alt = photo.alt || this.studio.name;
          next.sizes = '(min-width: 1400px) 760px, (min-width: 1000px) 52vw, 100vw';
          next.srcset = [480,720,1000,1440].map(width => `${this.imageUrl(photo.url,width)} ${width}w`).join(', ');
          next.src = this.imageUrl(photo.url,1440); next.decoding = 'async';
          await next.decode();
          if (sequence !== this.imageSequence || !this.isConnected) return;
          current?.replaceWith(next);
          if (!current) panel.prepend(next);
          this.querySelector('.jba-studio__image-empty')?.remove();
          if (animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) next.animate([{opacity:.7},{opacity:1}],{duration:160,easing:'ease-out'});
        }
        if (sequence !== this.imageSequence || !this.isConnected) return;
        this.currentPhoto = photo;
        this.galleryIndex = index;
        this.querySelector('[data-photo-zoom]').disabled = false;
        this.querySelectorAll('[data-photo-index]').forEach(button => {
          const selected = Number(button.dataset.photoIndex) === index;
          button.setAttribute('aria-pressed',String(selected));
          button.tabIndex = selected ? 0 : -1;
        });
        this.querySelector('[data-photo-counter]').textContent = `${index + 1} / ${this.gallery.length}`;
        this.updateVisualNote(); this.updateWishlist();
      } catch {
        if (sequence === this.imageSequence && this.isConnected) {
          this.querySelector('[data-image-status]').textContent = this.labels.imageError;
          this.querySelector('[data-image-retry]').hidden = false;
          if (!this.currentPhoto) this.querySelector('[data-photo-zoom]').disabled = true;
        }
      } finally {
        if (sequence === this.imageSequence && this.isConnected) {
          panel.setAttribute('aria-busy','false');
          this.querySelector('[data-image-loading]').hidden = true;
        }
      }
    }
    updateVisualNote() {
      const photo = this.currentPhoto;
      const note = this.querySelector('[data-visual-note]');
      if (!photo) { note.textContent = this.labels.photoReference; return; }
      const metal = this.metals.find(value => value.id === photo.metalId)?.label || photo.metalId;
      const shape = this.shapes.find(value => value.id === photo.shapeId)?.label || photo.shapeId;
      const shown = [metal,shape,`${photo.carat} ${this.labels.ct}`];
      if (Number(photo.width) > 0) shown.push(`${photo.width} ${this.labels.mm}`);
      note.textContent = `${this.labels.shownIn} ${shown.join(' · ')}`;
      note.dataset.exactMatch = String(this.imageMatches(photo));
      this.querySelector('[data-photo-disclosure]').textContent = this.imageMatches(photo) ? this.labels.photoMatch : this.labels.photoReference;
    }
    openPhoto() {
      if (!this.currentPhoto?.url) return;
      const dialog = this.querySelector('[data-photo-dialog]');
      dialog.querySelector('[data-zoom-caption]').textContent = this.querySelector('[data-visual-note]').textContent;
      if (!dialog.open) dialog.showModal();
      this.loadZoom();
    }
    async loadZoom() {
      const photo = this.currentPhoto;
      if (!photo) return;
      const sequence = (this.zoomSequence || 0) + 1;
      this.zoomSequence = sequence;
      const dialog = this.querySelector('[data-photo-dialog]');
      const image = dialog.querySelector('img');
      const displayed = this.querySelector('.jba-studio__image');
      image.src = displayed.currentSrc || displayed.src;
      image.alt = photo.alt || this.studio.name;
      dialog.setAttribute('aria-busy','true');
      this.querySelector('[data-zoom-status]').textContent = this.labels.loadingDetail;
      this.querySelector('[data-zoom-retry]').hidden = true;
      const detail = new Image();
      detail.src = this.imageUrl(photo.url,2400);
      try {
        await detail.decode();
        if (sequence !== this.zoomSequence || !dialog.open) return;
        image.src = detail.src;
        this.querySelector('[data-zoom-status]').textContent = '';
      } catch {
        if (sequence === this.zoomSequence && dialog.open) {
          this.querySelector('[data-zoom-status]').textContent = this.labels.zoomError;
          this.querySelector('[data-zoom-retry]').hidden = false;
        }
      } finally {
        if (sequence === this.zoomSequence) dialog.setAttribute('aria-busy','false');
      }
    }
    updateUrl() {
      if (!this.current) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant',String(this.current[0]));
      for (const [param,selector] of [['jba_size','[data-ring-size]'],['jba_length','[data-length-select]']]) {
        const value = this.querySelector(selector)?.value;
        if (value) url.searchParams.set(param,value); else url.searchParams.delete(param);
      }
      url.searchParams.delete('jba_hand_width'); url.searchParams.delete('section_id');
      history.replaceState(history.state,'',url);
    }
    wishlistItem() {
      const configuration = this.configuration();
      return {id:String(this.studio.id || this.dataset.productId),title:this.studio.name,url:window.location.href,image:this.currentPhoto?.url || this.querySelector('.jba-studio__image')?.src,variantId:String(this.current?.[0] || ''),configuration:{shape:configuration.shape,metal:configuration.metal,carat:configuration.carat,width:configuration.width,size:this.querySelector('[data-ring-size]')?.value || '',length:configuration.length || '',production:configuration.productionId}};
    }
    updateWishlist() {
      const button = this.querySelector('[data-jba-wishlist-toggle]');
      const saved = Boolean(window.JBAWishlist?.has?.(this.wishlistItem()));
      button.setAttribute('aria-pressed',String(saved)); button.setAttribute('aria-label',saved ? this.labels.saved : this.labels.save);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jba-wishlist"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jba-wishlist-page')) customElements.define('jba-wishlist-page', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.renderSaved = () => this.render();
    document.addEventListener('jba:wishlist-ready', this.renderSaved);
    document.addEventListener('jba:wishlist-updated', this.renderSaved);
    this.render();
  }
  disconnectedCallback() {
    document.removeEventListener('jba:wishlist-ready', this.renderSaved);
    document.removeEventListener('jba:wishlist-updated', this.renderSaved);
    this.initialized = false;
  }
  render() {
    if (!window.JBAWishlist) return;
    const items = window.JBAWishlist.getItems();
    const grid = this.querySelector('[data-jba-wishlist-grid]');
    const make = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text) node.textContent = text; return node; };
    grid.replaceChildren();
    items.forEach(item => {
      const article = make('article', 'jba-wishlist-page__card');
      const media = make('a', 'jba-wishlist-page__image'); media.href = item.url; media.setAttribute('aria-label', item.title);
      if (item.image) { const image = make('img'); image.src = item.image; image.alt = item.title; image.width = 600; image.height = 600; image.loading = 'lazy'; image.decoding = 'async'; media.append(image); }
      const title = make('h2'); const titleLink = make('a', '', item.title); titleLink.href = item.url; title.append(titleLink);
      const formatted = Object.entries(item.configuration).map(([key, value]) => { const format = this.dataset[key + 'Format']; if (format) return format.replace('__VALUE__', value); if (key === 'shape' || key === 'production') return value.charAt(0).toUpperCase() + value.slice(1); return value; });
      const detail = make('p', 'jba-wishlist-page__configuration', formatted.join(' · '));
      const actions = make('div', 'jba-wishlist-page__actions');
      const explore = make('a', '', this.dataset.exploreLabel); explore.href = item.url;
      const remove = make('button', '', this.dataset.removeLabel); remove.type = 'button'; remove.setAttribute('aria-label', this.dataset.removeLabel + ' ' + item.title); remove.addEventListener('click', () => { const index = items.indexOf(item); window.JBAWishlist.remove(item.key); const next = grid.querySelectorAll('button')[Math.min(index, grid.querySelectorAll('button').length - 1)]; if (next) next.focus(); else this.querySelector('[data-jba-wishlist-empty] a').focus(); });
      actions.append(explore, remove); article.append(media, title, detail, actions); grid.append(article);
    });
    this.querySelector('[data-jba-wishlist-empty]').hidden = items.length > 0;
    this.querySelector('[data-jba-wishlist-summary]').textContent = items.length === 1 ? this.dataset.countSingular : this.dataset.countLabel.replace('__COUNT__', String(items.length));
    if (!window.JBAWishlist.isPersistent()) this.querySelector('[data-jba-wishlist-scope]').textContent = this.dataset.sessionLabel;
  }
});

  } catch(e) { console.error(e); }
})();
})();
